module.exports = __webpack_public_path__ + "img/slide12.92e020c5.png";